import type { Dim } from './const';
import { normalizeToPx, MM_PER_INCH, PT_PER_INCH, PX_PER_INCH } from './const';

export class Dimension {
  readonly px: number;

  constructor(value: Dim) {
    this.px = normalizeToPx(value);
  }

  get pt() {
    return this.px * (PT_PER_INCH / PX_PER_INCH);
  }

  get mm() {
    return this.px * (MM_PER_INCH / PX_PER_INCH);
  }

  get vw() {
    return (this.px / this.px) * 100;
  }

  get vh() {
    return (this.px / this.px) * 100;
  }

  get smallerThanScreenWidth() {
    return this.px < this.px;
  }

  get biggerOrEqScreenWidth() {
    return !this.smallerThanScreenWidth;
  }
}
